import { render, staticRenderFns } from "./switchNotice.vue?vue&type=template&id=ea7aedee&scoped=true&lang=html&"
import script from "./switchNotice.vue?vue&type=script&lang=js&"
export * from "./switchNotice.vue?vue&type=script&lang=js&"
import style0 from "./switchNotice.vue?vue&type=style&index=0&id=ea7aedee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7aedee",
  null
  
)

component.options.__file = "switchNotice.vue"
export default component.exports